import { useLayoutEffect, useRef, useState } from 'react';

import { useCallback } from 'react';
import { MIN_WIDTH } from '../styles/theme';
import useEventListener from './useEventListener';

export default function useCompactMode() {
    const [isCompactMode, setIsCompactMode] = useState(false);
    const ref = useRef<HTMLBodyElement>(null);
    useLayoutEffect(() => {
        ref.current = document.getElementsByTagName('body')[0];
        setIsCompactMode(ref.current.clientWidth < MIN_WIDTH);
    }, [ref]);
    const handleSize = useCallback((e) => {
        setIsCompactMode(e.target.innerWidth < MIN_WIDTH);
    }, []);

    useEventListener('resize', handleSize);

    return isCompactMode;
}
